export type Language = "ne" | "en";

interface Translations {
  [key: string]: any;
}

export const translations: Record<Language, Translations> = {
  ne: {
    common: {
      appName: "साझा सोशल",
      home: "गृहपृष्ठ",
      search: "खोज्नुहोस्",
      post: "पोस्ट",
      profile: "प्रोफाइल",
      logout: "लग आउट",
      cancel: "रद्द गर्नुहोस्",
      submit: "पेश गर्नुहोस्",
      like: "मन पर्यो",
      comment: "टिप्पणी",
      share: "साझेदारी",
      follow: "फलो गर्नुहोस्",
      following: "फलो गर्दै",
      followers: "फलोअर्स",
      posts: "पोस्टहरू",
      about: "बारेमा",
      bio: "परिचय",
      location: "स्थान",
      joinDate: "सामेल भएको मिति",
      jobs: "जागिरहरू",
      housing: "आवास",
      business: "व्यवसाय",
      relationships: "सम्बन्ध",
      messages: "सन्देशहरू",
      events: "कार्यक्रमहरू",
      companies: "व्यवसायहरू",
      send: "पठाउनुहोस्",
      save: "सुरक्षित गर्नुहोस्",
      create: "बनाउनुहोस्",
      back: "फिर्ता",
      loadMore: "थप लोड गर्नुहोस्",
      allTypes: "सबै प्रकार",
      anonymous: "गुमनाम",
      sending: "पठाउँदै...",
      creating: "बनाउँदै...",
      saving: "सुरक्षित गर्दै...",
      posting: "पोस्ट गर्दै...",
      noResults: "कुनै परिणाम फेला परेन",
      owner: "व्यवसायी",
      by: "द्वारा",
      error: "केही गडबड भयो",
    },
    landing: {
      tagline: "विश्वभरका नेपाली समुदायको लागि",
      description: "साझा सोशल एक सामाजिक सञ्जाल हो जसले नेपाली समुदायलाई जोड्दछ।",
      getStarted: "सुरु गर्नुहोस्",
      browseAsGuest: "पाहुनाको रूपमा हेर्नुहोस्",
      login: "लग इन",
      communityPlatform: "नेपाली सामाजिक सञ्जाल ",
      whatIs: "साझा सोशल के हो?",
      whatIsDescription: "साझा सोशल नेपाली समुदायलाई डिजिटल रूपमा एकसाथ ल्याउने एक सामाजिक सञ्जाल हो।",
      jobsDesc: "जागिर खोज्नुहोस् वा जागिर अफर पोस्ट गर्नुहोस्। तपाईंको करियर यहाँबाट सुरु हुन्छ।",
      housingDesc: "घर, कोठा, वा अपार्टमेन्ट खोज्नुहोस् वा प्रस्ताव गर्नुहोस्।",
      friendsDesc: "नयाँ साथीहरू बनाउनुहोस्, गतिविधि साझेदारहरू फेला पार्नुहोस्।",
      companiesDesc: "आफ्नो व्यवसाय प्रोफाइल सिर्जना गर्नुहोस् र ग्राहकहरूसँग जडान हुनुहोस्।",
      eventsDesc: "कार्यक्रमहरू सिर्जना गर्नुहोस् र RSVP गर्नुहोस्। समुदाय सँगै आउँछ।",
      messagingDesc: "पोस्ट वा व्यवसायहरू बारे सोधपुछ पठाउनुहोस्।",
      jobs: "रोजगार",
      housing: "आवास",
      friends: "साथीहरू",
      companies: "व्यवसायहरू",
      events: "कार्यक्रमहरू",
      messaging: "सन्देशहरू",
      features: {
        community: {
          title: "समुदाय",
          description: "छलफल गर्नुहोस्, प्रश्न सोध्नुहोस्, र नेपालीहरूसँग जडान गर्नुहोस्",
        },
        jobs: {
          title: "जागिरहरू",
          description: "जागिर पोस्ट गर्नुहोस् वा जागिर खोज्नुहोस् र आवेदन दिनुहोस्",
        },
        housing: {
          title: "आवास",
          description: "कोठा भाडामा दिनुहोस् वा खोज्नुहोस्",
        },
        relationships: {
          title: "सम्बन्ध",
          description: "मित्रता, डेटिङ, वा विवाहको लागि जोडिनुहोस्",
        },
        business: {
          title: "व्यवसाय निर्देशिका",
          description: "आफ्नो व्यवसाय सूचीबद्ध गर्नुहोस् र उत्पादन र सेवाहरूको मार्केटिङ गर्नुहोस्",
        },
        events: {
          title: "कार्यक्रमहरू",
          description: "समुदायका कार्यक्रमहरू सिर्जना गर्नुहोस् र RSVP गर्नुहोस्",
        },
      },
      featuresTitle: "साझा सोशलले के प्रदान गर्छ?",
      featuresSubtitle: "एउटै प्लेटफर्ममा नेपाली समुदायका लागि सबै कुरा",
      ctaTitle: "आजै सामेल हुनुहोस्",
      ctaSubtitle: "विश्वभरका नेपालीहरूसँग जोडिनुहोस्।",
      ctaButton: "खाता बनाउनुहोस्",
      footer: {
        copyright: "© २०२६ साझा सोशल। सबै अधिकार सुरक्षित।",
        terms: "सेवाका सर्तहरू",
        privacy: "गोपनीयता नीति",
        about: "हाम्रो बारेमा",
        contact: "सम्पर्क गर्नुहोस्",
        madeFor: "नेपाली समुदायको लागि बनाइएको ❤️",
      },
    },
    auth: {
      welcomeBack: "फेरि स्वागत छ",
      createAccount: "खाता बनाउनुहोस्",
      firstName: "पहिलो नाम",
      lastName: "थर",
      username: "प्रयोगकर्ता नाम",
      email: "इमेल",
      password: "पासवर्ड",
      login: "लग इन",
      signup: "साइन अप",
      emailOrUsername: "इमेल वा प्रयोगकर्ता नाम",
      emailPlaceholder: "आफ्नो इमेल प्रविष्ट गर्नुहोस्",
      passwordPlaceholder: "आफ्नो पासवर्ड प्रविष्ट गर्नुहोस्",
      emailOrUsernamePlaceholder: "इमेल वा प्रयोगकर्ता नाम प्रविष्ट गर्नुहोस्",
      firstNamePlaceholder: "आफ्नो पहिलो नाम प्रविष्ट गर्नुहोस्",
      lastNamePlaceholder: "आफ्नो थर प्रविष्ट गर्नुहोस्",
      usernamePlaceholder: "प्रयोगकर्ता नाम छान्नुहोस्",
      noAccount: "खाता छैन?",
      hasAccount: "पहिले नै खाता छ?",
      tagline: "आफ्नो समुदायसँग जोडिनुहोस्",
      joinCommunity: "आज समुदायमा सामेल हुनुहोस्",
      terms: "म सेवाका सर्तहरू र गोपनीयता नीतिसँग सहमत छु",
      termsRequired: "कृपया सेवाका सर्तहरूमा सहमत हुनुहोस्",
      viewTerms: "सेवाका सर्तहरू हेर्नुहोस्",
      forgotPassword: "पासवर्ड बिर्सनुभयो?",
      forgotPasswordTitle: "पासवर्ड बिर्सनुभयो",
      forgotPasswordDesc: "तपाईंको इमेल वा प्रयोगकर्ता नाम प्रविष्ट गर्नुहोस् र हामी तपाईंलाई रिसेट कोड पठाउनेछौं।",
      backToLogin: "लगइनमा फिर्ता",
      resetPassword: "पासवर्ड रिसेट गर्नुहोस्",
      resetPasswordDesc: "आफ्नो रिसेट कोड र नयाँ पासवर्ड प्रविष्ट गर्नुहोस्।",
      newPassword: "नयाँ पासवर्ड",
      confirmPassword: "पासवर्ड पुष्टि गर्नुहोस्",
      passwordsDoNotMatch: "पासवर्डहरू मेल खाँदैनन्",
      passwordResetSuccess: "पासवर्ड सफलतापूर्वक रिसेट भयो! कृपया आफ्नो नयाँ पासवर्डले लगइन गर्नुहोस्।",
      verifyEmailTitle: "आफ्नो इमेल प्रमाणित गर्नुहोस्",
      verifyEmailSubtitle: "इमेल प्रमाणीकरण",
      verifyEmailDesc: "तपाईंको इमेल ठेगानामा पठाइएको ६-अंकको कोड प्रविष्ट गर्नुहोस्।",
      verifyYourEmail: "इमेल प्रमाणित गर्नुहोस्",
      verificationCode: "प्रमाणीकरण कोड",
      verifyButton: "इमेल प्रमाणित गर्नुहोस्",
      resendCode: "कोड पुन: पठाउनुहोस्",
      resending: "पुन: पठाउँदै...",
      sendResetCode: "रिसेट कोड पठाउनुहोस्",
      resetCode: "रिसेट कोड",
      devCode: "डेभ कोड",
      codeSentSuccess: "प्रमाणीकरण कोड पुन: पठाइयो। कृपया आफ्नो इमेल जाँच गर्नुहोस्।",
      invalidCredentials: "अमान्य इमेल/प्रयोगकर्ता नाम वा पासवर्ड",
      verifyEmailFirst: "लगइन गर्नु अघि कृपया आफ्नो इमेल प्रमाणित गर्नुहोस्",
      accountNotActive: "खाता सक्रिय छैन",
      usernameInvalid: "प्रयोगकर्ता नाम ३-२० अक्षरको हुनुपर्छ, अक्षरबाट सुरु हुनुपर्छ, र केवल अक्षर, नम्बर, _, -, वा . समावेश गर्न सक्छ",
      passwordTooShort: "पासवर्ड कम्तिमा ६ अक्षरको हुनुपर्छ",
      passwordTooLong: "पासवर्ड अधिकतम ३० अक्षरको हुनुपर्छ",
      nameTooShort: "नाम कम्तिमा २ अक्षरको हुनुपर्छ",
      nameTooLong: "नाम अधिकतम २० अक्षरको हुनुपर्छ",
      verifyEmailPrompt: "इमेल प्रमाणीकरण बाँकी छ?",
      verifyFailed: "इमेल प्रमाणीकरण असफल भयो। कृपया पुन: प्रयास गर्नुहोस्।",
      resendFailed: "कोड पुन: पठाउन असफल भयो। कृपया पुन: प्रयास गर्नुहोस्।",
      emailRequired: "कृपया इमेल ठेगाना प्रविष्ट गर्नुहोस्",
      emailInvalid: "कृपया मान्य इमेल ठेगाना प्रविष्ट गर्नुहोस्",
      emailTaken: "यो इमेल ठेगाना पहिले नै दर्ता भएको छ",
      usernameTaken: "यो प्रयोगकर्ता नाम पहिले नै लिइएको छ",
      emailOrUsernameRequired: "कृपया इमेल वा प्रयोगकर्ता नाम प्रविष्ट गर्नुहोस्",
      passwordRequired: "कृपया पासवर्ड प्रविष्ट गर्नुहोस्",
      resetCodeRequired: "कृपया रिसेट कोड प्रविष्ट गर्नुहोस्",
      invalidResetCode: "रिसेट कोड अमान्य वा म्याद सकिएको छ",
      verificationCodeRequired: "कृपया प्रमाणीकरण कोड प्रविष्ट गर्नुहोस्",
      invalidVerificationCode: "प्रमाणीकरण कोड अमान्य वा म्याद सकिएको छ",
    },
    feed: {
      greeting: "स्वागत छ",
      whatsOnMind: "तपाईको मनमा के छ?",
      createPost: "पोस्ट बनाउनुहोस्",
      writeComment: "टिप्पणी लेख्नुहोस्...",
      justNow: "अहिले भर्खर",
      minutesAgo: "मिनेट अघि",
      hoursAgo: "घण्टा अघि",
      daysAgo: "दिन अघि",
      noPosts: "अझै पोस्टहरू छैनन्",
      noCommentsYet: "अझै टिप्पणीहरू छैनन्। पहिलो बन्नुहोस्!",
      postNotFound: "पोस्ट फेला परेन",
      postLoadError: "पोस्ट लोड गर्न सकिएन",
      joined: "सामेल भयो",
      postType: "पोस्ट प्रकार",
      selectPostType: "पोस्ट प्रकार छान्नुहोस्",
      generalDiscussion: "सामान्य छलफल",
      jobOffer: "जागिर प्रस्ताव",
      jobRequest: "जागिर खोज",
      housingOffer: "आवास प्रस्ताव",
      housingRequest: "आवास खोज",
      friendRequest: "साथी खोज",
      other: "अन्य",
      postAnonymously: "गुमनाम रूपमा पोस्ट गर्नुहोस्",
      loadMore: "थप लोड गर्नुहोस्",
      writeMessage: "सन्देश लेख्नुहोस्...",
    },
    messages: {
      title: "सन्देशहरू",
      noMessages: "अझै सन्देशहरू छैनन्।",
      writeMessage: "सन्देश लेख्नुहोस्...",
      inquiryThread: "सोधपुछ",
      postInquiry: "पोस्ट सोधपुछ",
      businessInquiry: "व्यवसाय सोधपुछ",
      unknown: "अज्ञात",
      back: "फिर्ता",
      viewPost: "पोस्ट हेर्नुहोस्",
      viewCompany: "कम्पनी हेर्नुहोस्",
    },
    events: {
      title: "कार्यक्रमहरू",
      createEvent: "कार्यक्रम बनाउनुहोस्",
      noEvents: "अझै कार्यक्रमहरू छैनन्।",
      upcomingOnly: "आगामी मात्र",
      going: "जाँदैछु",
      interested: "रुचि छ",
      maybe: "सायद",
      titleLabel: "शीर्षक",
      descriptionLabel: "विवरण",
      startTime: "सुरु समय",
      endTime: "अन्त्य समय (वैकल्पिक)",
      by: "आयोजक",
      organizer: "आयोजक",
      loadMore: "थप कार्यक्रमहरू",
      scheduled: "तालिकाबद्ध",
      ongoing: "चलिरहेको",
      completed: "सम्पन्न",
      cancelled: "रद्द",
      detailsSection: "विवरण",
      start: "सुरु",
      end: "अन्त्य",
      participants: "सहभागीहरू",
      notFound: "कार्यक्रम फेला परेन",
      loadError: "कार्यक्रम लोड गर्न सकिएन",
    },
    eventValidation: {
      titleRequired: "शीर्षक अनिवार्य छ",
      titleTooShort: "शीर्षक कम्तिमा २ अक्षरको हुनुपर्छ",
      startTimeRequired: "सुरु समय अनिवार्य छ",
      endBeforeStart: "अन्त्य समय सुरु समयभन्दा पछि हुनुपर्छ",
      countryRequired: "देश अनिवार्य छ",
    },
    search: {
      placeholder: "प्रयोगकर्ता, पोस्ट, कम्पनी, कार्यक्रमहरू खोज्नुहोस्...",
      startTyping: "खोज्न टाइप गर्न सुरु गर्नुहोस्...",
      noResultsFor: "यसका लागि कुनै परिणाम फेला परेन",
      users: "प्रयोगकर्ताहरू",
      posts: "पोस्टहरू",
      companies: "व्यवसायहरू",
      events: "कार्यक्रमहरू",
      all: "सबै",
    },
    jobs: {
      title: "जागिर शीर्षक",
      titlePlaceholder: "जस्तै: सफ्टवेयर डेभलपर चाहिन्छ",
      requirements: "आवश्यकता / विवरण",
      requirementsPlaceholder: "जागिरको विवरण, योग्यता, र जिम्मेवारीहरू...",
      payType: "तलब प्रकार",
      payRate: "तलब दर",
      currency: "मुद्रा",
      hourly: "प्रति घण्टा",
      salary: "मासिक तलब",
      commission: "कमिशन",
      contract: "अनुबन्ध",
      postJob: "जागिर पोस्ट गर्नुहोस्",
      apply: "आवेदन दिनुहोस्",
      applications: "आवेदनहरू",
      viewApplications: "आवेदनहरू हेर्नुहोस्",
    },
    housing: {
      title: "शीर्षक",
      titlePlaceholder: "जस्तै: २ BHK फ्ल्याट भाडामा",
      description: "विवरण",
      descriptionPlaceholder: "कोठा, सुविधा, र अन्य विवरणहरू...",
      location: "स्थान",
      locationPlaceholder: "जस्तै: काठमाडौं, नेपाल",
      monthlyRent: "मासिक भाडा",
      currency: "मुद्रा",
      availableFrom: "उपलब्ध मिति",
      postListing: "सूची पोस्ट गर्नुहोस्",
      contactOwner: "मालिकलाई सम्पर्क गर्नुहोस्",
    },
    business: {
      pageTitle: "व्यवसायहरू",
      name: "व्यवसाय नाम",
      namePlaceholder: "तपाईंको व्यवसायको नाम",
      description: "विवरण",
      descriptionPlaceholder: "तपाईं के उत्पादन वा सेवा प्रदान गर्नुहुन्छ?",
      contact: "सम्पर्क",
      contactPlaceholder: "फोन, इमेल, वा अन्य सम्पर्क जानकारी",
      location: "स्थान",
      locationPlaceholder: "तपाईंको व्यवसाय कहाँ अवस्थित छ?",
      website: "वेबसाइट",
      optional: "वैकल्पिक",
      createProfile: "प्रोफाइल सिर्जना गर्नुहोस्",
      inquire: "सोधपुछ गर्नुहोस्",
      viewInquiries: "सोधपुछहरू हेर्नुहोस्",
      filterByType: "प्रकार अनुसार फिल्टर",
      allTypes: "सबै प्रकार",
      companyType: "कम्पनी प्रकार",
      sendInquiry: "सोधपुछ पठाउनुहोस्",
      inquiryMessage: "सन्देश",
      inquiryPlaceholder: "आफ्नो सोधपुछ सन्देश लेख्नुहोस्...",
      inquiryToAnonymous: "यो पोस्ट गुमनाम छ। तपाईंको सोधपुछ पठाइनेछ र लेखकको परिचय गोप्य रहनेछ।",
      noCompanies: "अझै व्यवसाय छैन।",
      contactDetails: "सम्पर्क र विवरण",
      listed: "सूचीबद्ध",
      liked: "मन पर्यो",
      notFound: "कम्पनी फेला परेन",
      loadError: "कम्पनी लोड गर्न सकिएन",
      phoneOptional: "फोन (वैकल्पिक)",
      emailOptional: "इमेल (वैकल्पिक)",
      createCompany: "कम्पनी बनाउनुहोस्",
      selectCompanyType: "कम्पनी प्रकार छान्नुहोस्",
      owner: "व्यवसायी",
    },
    companyTypes: {
      groceryAndConvenienceStore: "किराना र सुविधा पसल",
      informationTechnology: "सूचना प्रविधि",
      foodAndRestaurant: "खाना र रेस्टुरेन्ट",
      personalServices: "व्यक्तिगत सेवाहरू",
      business: "व्यवसाय",
      engineering: "इन्जिनियरिङ",
      education: "शिक्षा",
      financeAndInsurance: "वित्त र बिमा",
      healthServices: "स्वास्थ्य सेवाहरू",
      hotelsAndMotels: "होटल र मोटेल",
      motorVehicle: "मोटर गाडी",
      agricultureAndWildlife: "कृषि र वन्यजीव",
      entertainment: "मनोरञ्जन",
      realEstateAndHousing: "घर-जग्गा र आवास",
      safetySecurityAndLegal: "सुरक्षा र कानूनी",
      transportation: "यातायात",
      other: "अन्य",
    },
    companyValidation: {
      nameRequired: "कम्पनीको नाम अनिवार्य छ",
      nameTooShort: "नाम कम्तिमा २ अक्षरको हुनुपर्छ",
      nameTooLong: "नाम अधिकतम १०० अक्षरको हुनुपर्छ",
      descriptionRequired: "विवरण अनिवार्य छ",
      descriptionTooShort: "विवरण कम्तिमा १० अक्षरको हुनुपर्छ",
      countryRequired: "देश अनिवार्य छ",
      emailInvalid: "कृपया मान्य इमेल ठेगाना प्रविष्ट गर्नुहोस्",
      typeRequired: "कम्पनी प्रकार अनिवार्य छ",
    },
    relationship: {
      type: "प्रकार",
      friendship: "मित्रता",
      dating: "डेटिङ",
      marriage: "विवाह",
      about: "आफ्नो बारेमा",
      aboutPlaceholder: "आफ्नो बारेमा केही बताउनुहोस्...",
      lookingFor: "तपाईं के खोज्दै हुनुहुन्छ",
      lookingForPlaceholder: "तपाईं कस्तो व्यक्ति खोज्दै हुनुहुन्छ?",
      ageRange: "उमेर दायरा",
      ageRangePlaceholder: "जस्तै: २५-३५",
      location: "स्थान प्राथमिकता",
      locationPlaceholder: "जस्तै: काठमाडौं वा विश्वभर",
      createPost: "पोस्ट बनाउनुहोस्",
      connect: "जडान गर्नुहोस्",
    },
    location: {
      sectionLabel: "स्थान",
      country: "देश",
      city: "शहर",
      stateProvince: "राज्य / प्रदेश",
      address: "ठेगाना (वैकल्पिक)",
      cityPlaceholder: "जस्तै: काठमाडौं",
      statePlaceholder: "जस्तै: बागमती",
      addressPlaceholder: "जस्तै: ठमेल, वार्ड नं. ३",
      countryRequired: "देश अनिवार्य छ",
      promptTitle: "तपाईं कहाँ हुनुहुन्छ?",
      promptDesc: "तपाईंको क्षेत्रबाट सान्दर्भिक सामग्री देखाउनका लागि देश छान्नुहोस्।",
      promptAction: "सुरक्षित गर्नुहोस्",
      promptSkip: "पछि गर्नुहोस्",
      useCurrentLocation: "हालको स्थान प्रयोग गर्नुहोस्",
      detectingLocation: "पत्ता लगाउँदै...",
      locationDetected: "GPS निर्देशांक प्राप्त भयो",
      locationDetectError: "स्थान पत्ता लगाउन सकिएन",
    },
    profile: {
      memberSince: "सदस्य भएदेखि",
      editProfile: "प्रोफाइल सम्पादन गर्नुहोस्",
      noPosts: "अझै पोस्टहरू छैनन्।",
      noCompanies: "अझै व्यवसायहरू छैनन्।",
      emailLabel: "इमेल",
      userNotFound: "प्रयोगकर्ता फेला परेन",
      postedAnonymously: "गुमनाम रूपमा पोस्ट गरिएको",
    },
    terms: {
      title: "सेवाका सर्तहरू र गोपनीयता नीति",
      back: "फिर्ता",
      intro: {
        title: "परिचय",
        lastUpdated: "अन्तिम अद्यावधिक: मार्च २०२६",
        welcome: "साझा सोशलमा तपाईंलाई स्वागत छ। यी सेवाका सर्तहरू ('सर्तहरू') ले हाम्रो प्लेटफर्मको प्रयोग नियन्त्रण गर्दछ। हाम्रो सेवा प्रयोग गरेर, तपाईं यी सर्तहरूमा सहमत हुनुहुन्छ।",
      },
      acceptance: {
        title: "सर्तहरूको स्वीकृति",
        content1: "साझा सोशल प्रयोग गरेर, तपाईं यी सेवाका सर्तहरू र हाम्रो गोपनीयता नीतिमा बाध्य हुन सहमत हुनुहुन्छ। यदि तपाईं यी सर्तहरूसँग सहमत हुनुहुन्न भने, कृपया हाम्रो सेवा प्रयोग नगर्नुहोस्।",
        content2: "तपाईंले साझा सोशलमा खाता सिर्जना गरेर, तपाईंले सत्य, सटीक र पूर्ण जानकारी प्रदान गर्नुभएको पुष्टि गर्नुहुन्छ।",
        footer: "यी सेवाका सर्तहरू स्वीकार गरेर, तपाईंले साझा सोशलको सबै नियम र नीतिहरू पालना गर्न सहमत हुनुहुन्छ।",
      },
      dataCollection: {
        title: "प्रयोगकर्ता डेटा संकलन र प्रयोग",
        intro: "हामी तपाईंको अनुभव सुधार गर्न र हाम्रो सेवाहरू प्रदान गर्न निम्न जानकारी संकलन गर्छौं:",
        item1: "व्यक्तिगत जानकारी: नाम, इमेल ठेगाना, प्रयोगकर्ता नाम, र प्रोफाइल जानकारी",
        item2: "सामग्री डेटा: पोस्टहरू, टिप्पणीहरू, कार्यक्रमहरू, व्यवसायहरू र तपाईंले साझेदारी गर्नुभएको अन्य कुनै पनि सामग्री",
        item3: "प्रयोग डेटा: तपाईं हाम्रो सेवासँग कसरी अन्तरक्रिया गर्नुहुन्छ, हेरिएको सामग्री, र सुविधा प्रयोग",
        item4: "यन्त्र जानकारी: IP ठेगाना, ब्राउजर प्रकार, अपरेटिङ सिस्टम, र यन्त्र पहिचानकर्ता",
        item5: "स्थान डेटा: तपाईंको सहमतिमा आधारित स्थान जानकारी",
      },
      advertising: {
        title: "विज्ञापन र मार्केटिङ",
        content1: "साझा सोशल तपाईंको रुचि र व्यवहारमा आधारित लक्षित विज्ञापनहरू प्रदर्शन गर्न तपाईंको डेटा प्रयोग गर्दछ। यसमा तपाईंको प्रोफाइल जानकारी, सामग्री अन्तरक्रिया, यन्त्र जानकारी, स्थान डेटा र ब्राउजिङ इतिहासको विश्लेषण समावेश छ।",
        content2: "हामी विज्ञापन प्रभावकारिता मापन गर्न र व्यक्तिगत विज्ञापनहरू प्रदान गर्न तेस्रो-पक्ष विज्ञापन साझेदारहरूसँग तपाईंको जानकारी साझेदारी गर्न सक्छौं। यी साझेदारहरूले तिनीहरूको आफ्नै कुकीहरू र ट्र्याकिङ प्रविधिहरू प्रयोग गर्न सक्छन्।",
        content3: "माथि उल्लेखित डेटा संकलन र विज्ञापन गतिविधिहरू हाम्रो प्लेटफर्मलाई राजस्व आर्जन गर्न र निःशुल्क सेवा प्रदान गर्न जारी राख्न मद्दत गर्दछ।",
      },
      userContent: {
        title: "प्रयोगकर्ता सामग्री र आचरण",
        intro: "तपाईंले साझा सोशलमा पोस्ट गर्नुभएको कुनै पनि सामग्रीको लागि तपाईं जिम्मेवार हुनुहुन्छ। निम्न निषेधित छ:",
        prohibited1: "अवैध, हानिकारक, धम्कीपूर्ण, अपमानजनक, उत्पीडक, वा आपत्तिजनक सामग्री",
        prohibited2: "झूटा वा भ्रामक जानकारी जसले अरूलाई हानि पुर्याउन सक्छ",
        prohibited3: "बौद्धिक सम्पत्ति अधिकारको उल्लङ्घन गर्ने सामग्री",
        prohibited4: "स्प्याम, मालवेयर, वा फिसिङ प्रयासहरू",
        prohibited5: "घृणापूर्ण भाषण, भेदभाव, वा हिंसाको प्रवर्द्धन",
      },
      privacy: {
        title: "गोपनीयता र डेटा सुरक्षा",
        content1: "हामी तपाईंको व्यक्तिगत जानकारी अनधिकृत पहुँच, परिमार्जन, प्रकटीकरण, वा विनाशबाट जोगाउन उद्योग-मानक सुरक्षा उपायहरू प्रयोग गर्छौं।",
        content2: "तथापि, इन्टरनेटमा कुनै पनि डेटा प्रसारण १००% सुरक्षित छैन। हामी तपाईंको जानकारीको सुरक्षाको ग्यारेन्टी गर्न सक्दैनौं, तर हामी यसको सुरक्षाको लागि सबै प्रयास गर्छौं।",
      },
      thirdParty: {
        title: "तेस्रो-पक्ष सेवाहरू",
        content: "साझा सोशलमा तेस्रो-पक्ष वेबसाइटहरू वा सेवाहरूमा लिङ्कहरू हुन सक्छन्। हामी तेस्रो-पक्ष साइटहरूको सामग्री, गोपनीयता नीति, वा अभ्यासहरूको लागि जिम्मेवार छैनौं। तपाईंले कुनै पनि तेस्रो-पक्ष सेवा प्रयोग गर्नु अघि तिनीहरूको सर्तहरू समीक्षा गर्नुपर्छ।",
      },
      intellectual: {
        title: "बौद्धिक सम्पत्ति",
        content1: "साझा सोशल प्लेटफर्म, लोगो, र सामग्री (प्रयोगकर्ता-उत्पन्न सामग्री बाहेक) साझा सोशलको सम्पत्ति हो र बौद्धिक सम्पत्ति कानूनद्वारा संरक्षित छ।",
        content2: "तपाईंले साझा सोशलमा सामग्री पोस्ट गरेर, तपाईंले हामीलाई तपाईंको सामग्री प्रदर्शन गर्न, वितरण गर्न, र प्रवर्द्धन गर्न विश्वव्यापी, गैर-विशेष, रोयल्टी-मुक्त इजाजतपत्र प्रदान गर्नुहुन्छ।",
      },
      termination: {
        title: "खाता समाप्ति",
        content: "हामी कुनै पनि समय, कुनै कारण बिना, सूचना बिना तपाईंको खाता निलम्बन वा समाप्त गर्ने अधिकार सुरक्षित राख्छौं। तपाईं पनि कुनै पनि समय आफ्नो खाता बन्द गर्न सक्नुहुन्छ। समाप्ति पछि, तपाईंले पोस्ट गर्नुभएको सामग्री हाम्रो प्लेटफर्ममा रहन सक्छ।",
      },
      liability: {
        title: "दायित्वको सीमा",
        content: "साझा सोशल 'जस्तो छ' र 'उपलब्ध छ' आधारमा प्रदान गरिन्छ। हामी सेवाको उपलब्धता, शुद्धता, वा विश्वसनीयताको ग्यारेन्टी गर्दैनौं। हामी प्रत्यक्ष, अप्रत्यक्ष, आकस्मिक, वा परिणामी क्षतिहरूको लागि उत्तरदायी हुनेछैनौं।",
      },
      changes: {
        title: "सर्तहरूमा परिवर्तनहरू",
        content: "हामी कुनै पनि समय यी सर्तहरू परिमार्जन गर्न सक्छौं। हामी तपाईंलाई महत्त्वपूर्ण परिवर्तनहरूको बारेमा इमेल वा सेवा सूचनाहरू मार्फत सूचित गर्नेछौं। परिवर्तनहरू पोस्ट गरिए पछि साझा सोशल प्रयोग जारी राख्नाले नयाँ सर्तहरूको स्वीकृति संकेत गर्दछ।",
      },
      law: {
        title: "शासक कानून",
        content: "यी सर्तहरू आवश्यकतानुसार लागू स्थानीय, राज्य र सरकारी कानूनद्वारा शासित हुनेछन्। यी सर्तहरूबाट उत्पन्न हुने कुनै पनि विवाद उचित अधिकार क्षेत्रको अधीनमा हुनेछ।",
      },
      contact: {
        title: "सम्पर्क जानकारी",
        intro: "यदि तपाईंसँग यी सेवाका सर्तहरूको बारेमा कुनै प्रश्नहरू छन् भने, कृपया हामीलाई सम्पर्क गर्नुहोस्:",
      },
    },
  },
  en: {
    common: {
      appName: "Sajha Social",
      home: "Home",
      search: "Search",
      post: "Post",
      profile: "Profile",
      logout: "Logout",
      cancel: "Cancel",
      submit: "Submit",
      like: "Like",
      comment: "Comment",
      share: "Share",
      follow: "Follow",
      following: "Following",
      followers: "Followers",
      posts: "Posts",
      about: "About",
      bio: "Bio",
      location: "Location",
      joinDate: "Join Date",
      jobs: "Jobs",
      housing: "Housing",
      business: "Business",
      relationships: "Relationships",
      messages: "Messages",
      events: "Events",
      companies: "Companies",
      send: "Send",
      save: "Save",
      create: "Create",
      back: "Back",
      loadMore: "Load More",
      allTypes: "All Types",
      anonymous: "Anonymous",
      sending: "Sending...",
      creating: "Creating...",
      saving: "Saving...",
      posting: "Posting...",
      noResults: "No results found",
      owner: "Owner",
      by: "By",
      error: "Something went wrong",
    },
    landing: {
      tagline: "For the Nepali community around the world",
      description: "Sajha Social is a social platform that connects the Nepali community.",
      getStarted: "Get Started",
      browseAsGuest: "Browse as guest",
      login: "Log In",
      communityPlatform: "Nepali Social Network",
      whatIs: "What is Sajha Social?",
      whatIsDescription: "Sajha Social is a comprehensive social network platform which digitally brings the Nepali community together.",
      jobsDesc: "Find jobs or post job offers. Your career starts here.",
      housingDesc: "Find or offer houses, rooms, and apartments.",
      friendsDesc: "Make new friends, find activity partners.",
      companiesDesc: "Create your business profile and connect with customers.",
      eventsDesc: "Create and RSVP to events. Bring the community together.",
      messagingDesc: "Send inquiries about posts or companies.",
      jobs: "Jobs",
      housing: "Housing",
      friends: "Friends",
      companies: "Companies",
      events: "Events",
      messaging: "Messaging",
      features: {
        community: {
          title: "Community",
          description: "Chat, ask questions, and connect with Nepalis",
        },
        jobs: {
          title: "Jobs",
          description: "Post jobs or search and apply for jobs",
        },
        housing: {
          title: "Housing",
          description: "Rent out or search for housing",
        },
        relationships: {
          title: "Relationships",
          description: "Connect for friendship, dating, or marriage",
        },
        business: {
          title: "Business Directory",
          description: "List your business and market your products and services",
        },
        events: {
          title: "Events",
          description: "Create and RSVP to community events near you",
        },
      },
      featuresTitle: "Everything the community needs",
      featuresSubtitle: "One platform built for Nepalis, wherever you are",
      ctaTitle: "Join today",
      ctaSubtitle: "Connect with Nepalis around the world.",
      ctaButton: "Create an account",
      footer: {
        copyright: "© 2026 Sajha Social. All rights reserved.",
        terms: "Terms of Service",
        privacy: "Privacy Policy",
        about: "About Us",
        contact: "Contact",
        madeFor: "Made with ❤️ for the Nepali community",
      },
    },
    auth: {
      welcomeBack: "Welcome Back",
      createAccount: "Create Account",
      firstName: "First Name",
      lastName: "Last Name",
      username: "Username",
      email: "Email",
      password: "Password",
      login: "Log In",
      signup: "Sign Up",
      emailOrUsername: "Email or Username",
      emailPlaceholder: "Enter your email",
      passwordPlaceholder: "Enter your password",
      emailOrUsernamePlaceholder: "Enter your email or username",
      firstNamePlaceholder: "Enter your first name",
      lastNamePlaceholder: "Enter your last name",
      usernamePlaceholder: "Choose a username",
      noAccount: "Don't have an account?",
      hasAccount: "Already have an account?",
      tagline: "Connect with your community",
      joinCommunity: "Join the community today",
      terms: "I agree to the Terms of Service and Privacy Policy",
      termsRequired: "Please agree to the terms and conditions",
      viewTerms: "View Terms of Service",
      forgotPassword: "Forgot password?",
      forgotPasswordTitle: "Forgot Password",
      forgotPasswordDesc: "Enter your email or username and we'll send you a reset code.",
      backToLogin: "Back to Login",
      resetPassword: "Reset Password",
      resetPasswordDesc: "Enter your reset code and new password.",
      newPassword: "New Password",
      confirmPassword: "Confirm Password",
      passwordsDoNotMatch: "Passwords do not match",
      passwordResetSuccess: "Password reset successful! Please log in with your new password.",
      verifyEmailTitle: "Verify Your Email",
      verifyEmailSubtitle: "Email Verification",
      verifyEmailDesc: "Enter the 6-digit code sent to your email address.",
      verifyYourEmail: "Verify your email",
      verificationCode: "Verification Code",
      verifyButton: "Verify Email",
      resendCode: "Resend Code",
      resending: "Resending...",
      sendResetCode: "Send Reset Code",
      resetCode: "Reset Code",
      devCode: "Dev code",
      codeSentSuccess: "Verification code resent. Please check your email.",
      invalidCredentials: "Invalid email/username or password",
      verifyEmailFirst: "Please verify your email before logging in",
      accountNotActive: "Account is not active. Please contact support.",
      usernameInvalid: "Username must be 3–20 characters, start with a letter, and only contain letters, numbers, _, -, or .",
      passwordTooShort: "Password must be at least 6 characters",
      passwordTooLong: "Password must be at most 30 characters",
      nameTooShort: "Name must be at least 2 characters",
      nameTooLong: "Name must be at most 20 characters",
      verifyEmailPrompt: "Haven't verified your email?",
      verifyFailed: "Email verification failed. Please try again.",
      resendFailed: "Failed to resend code. Please try again.",
      emailRequired: "Please enter your email address",
      emailInvalid: "Please enter a valid email address",
      emailTaken: "This email address is already registered",
      usernameTaken: "This username is already taken",
      emailOrUsernameRequired: "Please enter your email or username",
      passwordRequired: "Please enter your password",
      resetCodeRequired: "Please enter the reset code",
      invalidResetCode: "Reset code is invalid or has expired",
      verificationCodeRequired: "Please enter the verification code",
      invalidVerificationCode: "Verification code is invalid or has expired",
    },
    feed: {
      greeting: "Welcome back",
      whatsOnMind: "What's on your mind?",
      createPost: "Create Post",
      writeComment: "Write a comment...",
      justNow: "Just now",
      minutesAgo: "minutes ago",
      hoursAgo: "hours ago",
      daysAgo: "days ago",
      noPosts: "No posts yet",
      noCommentsYet: "No comments yet. Be the first!",
      postNotFound: "Post not found",
      postLoadError: "Failed to load post",
      joined: "Joined",
      postType: "Post Type",
      selectPostType: "Select Post Type",
      generalDiscussion: "General Discussion",
      jobOffer: "Job Offer",
      jobRequest: "Job Request",
      housingOffer: "Housing Offer",
      housingRequest: "Housing Request",
      friendRequest: "Friend Request",
      other: "Other",
      postAnonymously: "Post anonymously",
      loadMore: "Load More",
      writeMessage: "Write a message...",
    },
    messages: {
      title: "Messages",
      noMessages: "No messages yet.",
      writeMessage: "Write a message...",
      inquiryThread: "inquiry",
      postInquiry: "Post inquiry",
      businessInquiry: "Business inquiry",
      unknown: "Unknown",
      back: "Back",
      viewPost: "View post",
      viewCompany: "View company",
    },
    events: {
      title: "Events",
      createEvent: "Create Event",
      noEvents: "No events yet.",
      upcomingOnly: "Upcoming only",
      going: "going",
      interested: "interested",
      maybe: "maybe",
      titleLabel: "Title",
      descriptionLabel: "Description",
      startTime: "Start Time",
      endTime: "End Time (optional)",
      by: "Organizer",
      organizer: "Organizer",
      loadMore: "Load More Events",
      scheduled: "Scheduled",
      ongoing: "Ongoing",
      completed: "Completed",
      cancelled: "Cancelled",
      detailsSection: "Details",
      start: "Start",
      end: "End",
      participants: "Participants",
      notFound: "Event not found",
      loadError: "Failed to load event",
    },
    eventValidation: {
      titleRequired: "Title is required",
      titleTooShort: "Title must be at least 2 characters",
      startTimeRequired: "Start time is required",
      endBeforeStart: "End time must be after start time",
      countryRequired: "Country is required",
    },
    search: {
      placeholder: "Search users, posts, companies, events...",
      startTyping: "Start typing to search...",
      noResultsFor: "No results found for",
      users: "Users",
      posts: "Posts",
      companies: "Companies",
      events: "Events",
      all: "All",
    },
    jobs: {
      title: "Job Title",
      titlePlaceholder: "e.g., Software Developer Needed",
      requirements: "Requirements / Details",
      requirementsPlaceholder: "Job details, qualifications, and responsibilities...",
      payType: "Pay Type",
      payRate: "Pay Rate",
      currency: "Currency",
      hourly: "Per hour",
      salary: "Monthly Salary",
      commission: "Commission",
      contract: "Contract",
      postJob: "Post Job",
      apply: "Apply",
      applications: "Applications",
      viewApplications: "View Applications",
    },
    housing: {
      title: "Title",
      titlePlaceholder: "e.g., 2 BHK Flat for Rent",
      description: "Description",
      descriptionPlaceholder: "House, amenities, and other details...",
      location: "Location",
      locationPlaceholder: "e.g., Kathmandu, Nepal",
      monthlyRent: "Monthly Rent",
      currency: "Currency",
      availableFrom: "Available From",
      postListing: "Post Listing",
      contactOwner: "Contact Owner",
    },
    business: {
      pageTitle: "Businesses",
      name: "Business Name",
      namePlaceholder: "Your business name",
      description: "Description",
      descriptionPlaceholder: "What products or services do you offer?",
      contact: "Contact",
      contactPlaceholder: "Phone, email, or other contact information",
      location: "Location",
      locationPlaceholder: "Where is your business located?",
      website: "Website",
      optional: "Optional",
      createProfile: "Create Profile",
      inquire: "Inquire",
      viewInquiries: "View Inquiries",
      filterByType: "Filter by type",
      allTypes: "All Types",
      companyType: "Company Type",
      sendInquiry: "Send Inquiry",
      inquiryMessage: "Message",
      inquiryPlaceholder: "Write your inquiry message...",
      inquiryToAnonymous: "This post is anonymous. Your inquiry will be sent and the author's identity stays hidden.",
      noCompanies: "No business yet.",
      contactDetails: "Contact & Details",
      listed: "Listed",
      liked: "Liked",
      notFound: "Company not found",
      loadError: "Failed to load company",
      phoneOptional: "Phone (optional)",
      emailOptional: "Email (optional)",
      createCompany: "Create Company",
      selectCompanyType: "Select company type",
      owner: "Owner",
    },
    companyTypes: {
      groceryAndConvenienceStore: "Grocery and Convenience Store",
      informationTechnology: "Information Technology",
      foodAndRestaurant: "Food and Restaurant",
      personalServices: "Personal Services",
      business: "Business",
      engineering: "Engineering",
      education: "Education",
      financeAndInsurance: "Finance and Insurance",
      healthServices: "Health Services",
      hotelsAndMotels: "Hotels and Motels",
      motorVehicle: "Motor Vehicle",
      agricultureAndWildlife: "Agriculture and Wildlife",
      entertainment: "Entertainment",
      realEstateAndHousing: "Real Estate and Housing",
      safetySecurityAndLegal: "Safety, Security and Legal",
      transportation: "Transportation",
      other: "Other",
    },
    companyValidation: {
      nameRequired: "Company name is required",
      nameTooShort: "Name must be at least 2 characters",
      nameTooLong: "Name must be at most 100 characters",
      descriptionRequired: "Description is required",
      descriptionTooShort: "Description must be at least 10 characters",
      countryRequired: "Country is required",
      emailInvalid: "Please enter a valid email address",
      typeRequired: "Company type is required",
    },
    relationship: {
      type: "Type",
      friendship: "Friendship",
      dating: "Dating",
      marriage: "Marriage",
      about: "About Yourself",
      aboutPlaceholder: "Tell us a little about yourself...",
      lookingFor: "Looking For",
      lookingForPlaceholder: "What kind of person are you looking for?",
      ageRange: "Age Range",
      ageRangePlaceholder: "e.g., 25-35",
      location: "Location Preference",
      locationPlaceholder: "e.g., Kathmandu or worldwide",
      createPost: "Create Post",
      connect: "Connect",
    },
    location: {
      sectionLabel: "Location",
      country: "Country",
      city: "City",
      stateProvince: "State / Province",
      address: "Address (optional)",
      cityPlaceholder: "e.g., New York",
      statePlaceholder: "e.g., New York",
      addressPlaceholder: "e.g., 123 Main St",
      countryRequired: "Country is required",
      promptTitle: "Where are you located?",
      promptDesc: "Select your country to see relevant content from your area.",
      promptAction: "Save",
      promptSkip: "Skip for now",
      useCurrentLocation: "Use current location",
      detectingLocation: "Detecting...",
      locationDetected: "GPS coordinates captured",
      locationDetectError: "Could not detect location",
    },
    profile: {
      memberSince: "Member since",
      editProfile: "Edit Profile",
      noPosts: "No posts yet.",
      noCompanies: "No companies yet.",
      emailLabel: "Email",
      userNotFound: "User not found",
      postedAnonymously: "Posted anonymously",
    },
    terms: {
      title: "Terms of Service and Privacy Policy",
      back: "Back",
      intro: {
        title: "Introduction",
        lastUpdated: "Last Updated: March 2026",
        welcome: "Welcome to Sajha Social. These Terms of Service ('Terms') govern your use of our platform. By using our service, you agree to these terms.",
      },
      acceptance: {
        title: "Acceptance of Terms",
        content1: "By using Sajha Social, you agree to be bound by these Terms of Service and our Privacy Policy. If you do not agree to these terms, please do not use our service.",
        content2: "By creating an account on Sajha Social, you confirm that you have provided truthful, accurate, and complete information.",
        footer: "By accepting these Terms of Service, you agree to comply with all rules and policies of Sajha Social.",
      },
      dataCollection: {
        title: "User Data Collection and Usage",
        intro: "We collect the following information to improve your experience and provide our services:",
        item1: "Personal Information: Name, email address, username, and profile information",
        item2: "Content Data: Posts, comments, events, companies and any other content you share",
        item3: "Usage Data: How you interact with our service, content viewed, and feature usage",
        item4: "Device Information: IP address, browser type, operating system, and device identifiers",
        item5: "Location Data: Location information based on your consent",
      },
      advertising: {
        title: "Advertisement and Marketing",
        content1: "Sajha Social uses your data to display targeted advertisements based on your interests and behavior. This includes analyzing your profile information, content interactions, device information, location data and browsing history.",
        content2: "We may share your information with third-party advertising partners to measure ad effectiveness and deliver personalized ads. These partners may use their own cookies and tracking technologies.",
        content3: "The data collection and advertising activities described above help Sajha Social generate revenue and continue providing a free service to the community.",
      },
      userContent: {
        title: "User Content and Conduct",
        intro: "You are responsible for any content you post on Sajha Social. The following is prohibited:",
        prohibited1: "Illegal, harmful, threatening, abusive, harassing, or offensive content",
        prohibited2: "False or misleading information that could harm others",
        prohibited3: "Content that infringes on intellectual property rights",
        prohibited4: "Spam, malware, or phishing attempts",
        prohibited5: "Hate speech, discrimination, or promotion of violence",
      },
      privacy: {
        title: "Privacy and Data Security",
        content1: "We use industry-standard security measures to protect your personal information from unauthorized access, alteration, disclosure, or destruction.",
        content2: "However, no data transmission over the internet is 100% secure. We cannot guarantee the security of your information, but we strive to protect it.",
      },
      thirdParty: {
        title: "Third-Party Services",
        content: "Sajha Social may contain links to third-party websites or services. We are not responsible for the content, privacy policies, or practices of third-party sites. You should review their terms before using any third-party service.",
      },
      intellectual: {
        title: "Intellectual Property",
        content1: "The Sajha Social platform, logo, and content (excluding user-generated content) are the property of Sajha Social and protected by intellectual property laws.",
        content2: "By posting content on Sajha Social, you grant us a worldwide, non-exclusive, royalty-free license to display, distribute, and promote your content.",
      },
      termination: {
        title: "Account Termination",
        content: "We reserve the right to suspend or terminate your account at any time, for any reason, without notice. You may also close your account at any time. After termination, content you posted may remain on our platform.",
      },
      liability: {
        title: "Limitation of Liability",
        content: "Sajha Social is provided 'as is' and 'as available'. We do not guarantee the availability, accuracy, or reliability of the service. We shall not be liable for any direct, indirect, incidental, or consequential damages.",
      },
      changes: {
        title: "Changes to Terms",
        content: "We may modify these terms at any time. We will notify you of significant changes through email or service notifications. Continued use of Sajha Social after changes are posted indicates acceptance of the new terms.",
      },
      law: {
        title: "Governing Law",
        content: "These terms shall be governed by applicable local, state, and government law as required. Any disputes arising from these terms shall be subject to the appropriate jurisdiction.",
      },
      contact: {
        title: "Contact Information",
        intro: "If you have any questions about these Terms of Service, please contact us:",
      },
    },
  },
};